export default class OrderResponse{
    Status;
    Message;

    costructor(){}
}